var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowVeryLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7071 8.07112C24.0976 7.6806 24.0976 7.04743 23.7071 6.65691L17.3431 0.292946C16.9526 -0.0975785 16.3195 -0.0975785 15.9289 0.292946C15.5384 0.68347 15.5384 1.31664 15.9289 1.70716L21.5858 7.36401L15.9289 13.0209C15.5384 13.4114 15.5384 14.0446 15.9289 14.4351C16.3195 14.8256 16.9526 14.8256 17.3431 14.4351L23.7071 8.07112ZM0 7.36401V8.36401H23V7.36401V6.36401H0V7.36401Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowVeryLongRight);
export default __webpack_public_path__ + "static/media/arrow_very_long_right.04ddf833f43ac804122c28bbe81e88ca.svg";
export { ForwardRef as ReactComponent };